import { FuseRouteConfigsType } from "@fuse/utils/FuseUtils";
import AdminDashboardAppConfig from "./dashboard/AdminDashboardAppConfig";
import SendEmailAppConfig from "./sendemail/SendEmailAppConfig";
import AdminSearchAppConfig from "./adminsearch/AdminSearchAppConfig";
import AdminSitesAppConfig from "./adminsites/AdminSitesAppConfig";
import BulkPetUploadAppConfig from "./bulkpetupload/BulkPetUploadAppConfig";
import StripePricesAppConfig from "./stripeprices/StripePricesAppConfig";

/**
 * Dashboards
 */
const adminConfigs: FuseRouteConfigsType = [
	AdminDashboardAppConfig,
	SendEmailAppConfig,
	AdminSearchAppConfig,
	AdminSitesAppConfig,
	BulkPetUploadAppConfig,
	StripePricesAppConfig
];

export default adminConfigs;
